<template>
  <QCarousel
    v-model="slide"
    animated
    navigation
    swipeable
    autoplay
    infinite
    :padding="false"
    navigation-position="bottom"
    transition-prev="slide-right"
    transition-next="slide-left"
    class="w-full"
    @mouseenter="autoplay = false"
    @mouseleave="autoplay = true"
  >
    <template #navigation-icon="{ active, onClick }">
      <QBtn
        :color="active ? 'primary' : 'white'"
        class="w-10 min-h-0.5 !p-0"
        @click="onClick"
      />
    </template>
    <QCarouselSlide
      v-for="(banner,index) in banners"
      :name="index"
      :img-src="banner"
    />
  </QCarousel>
</template>

<script setup>
import { ref } from 'vue'
import Banner1 from '@/assets/home/banner-1.png'
import Banner2 from '@/assets/home/banner-2.png'
import Banner3 from '@/assets/home/banner-3.png'

const banners = [
  Banner1,
  Banner2,
  Banner3,
]
const slide = ref(1)
const autoplay = ref(true)
</script>
